import React, { useCallback, useEffect, useState } from 'react'
import { navigate, PageProps } from 'gatsby'
import { Form } from './Form'
import { contactField } from './Contact.module.scss'
import { Button } from '../../ui/Button'
import { ArrowRight } from '../../ui/Icon'
import { ExternalLink, InternalLink } from '../../ui/Link'

type Props = {
	location: PageProps['location']
}

export const ContactForm = ({ location }: Props) => {
	const [name, setName] = useState('')
	const [nameFurigana, setNameFurigana] = useState('')
	const [company, setCompany] = useState('')
	const [email, setEmail] = useState('')
	const [phoneNumber, setPhoneNumber] = useState('')
	const [content, setContent] = useState('')
	const [isSubmit, setIsSubmit] = useState(false)

	useEffect(() => {
		const { state } = location

		setName(state['name'] || '')
		setNameFurigana(state['nameFurigana'] || '')
		setCompany(state['company'] || '')
		setEmail(state['email'] || '')
		setPhoneNumber(state['phoneNumber'] || '')
		setContent(state['content'] || '')
	}, [location])

	const handleInputChange = useCallback((e: React.FormEvent<HTMLInputElement>) => {
		const { name, value } = e.currentTarget

		switch (name) {
			case 'name':
				setName(value)
				break
			case 'nameFurigana':
				setNameFurigana(value)
				break
			case 'company':
				setCompany(value)
				break
			case 'email':
				setEmail(value)
				break
			case 'phoneNumber':
				setPhoneNumber(value)
				break
			default:
				break
		}
	}, [])

	const handleTextareaChange = useCallback((e: React.FormEvent<HTMLTextAreaElement>) => {
		setContent(e.currentTarget.value)
	}, [])

	const handleFormSubmit = () => {
		setIsSubmit(true)

		if (!name || !nameFurigana || !email || !content) return

		navigate('/contact/confirm/', {
			state: { name, nameFurigana, company, email, phoneNumber, content },
		})
	}

	return (
		<div className="w-full bg-form">
			<div className={contactField}>
				<p className="text-sm text-left lg:text-center">内容確認後、担当より通常1〜3営業日以内にご連絡いたします</p>
				<div className="lg:p-10 py-10 px-5 mt-8 lg:mt-10 w-full bg-secondary rounded shadow">
					<p className="text-sm text-center">
						必要項目<span className="px-1 text-red">※</span>をご記入の上、お進みください
					</p>
					<form className="mt-8">
						<Form
							name={name}
							nameFurigana={nameFurigana}
							company={company}
							email={email}
							phoneNumber={phoneNumber}
							content={content}
							readOnly={false}
							isSubmit={isSubmit}
							handleInputChange={handleInputChange}
							handleTextareaChange={handleTextareaChange}
						/>
						<p className="mt-8 text-xs text-center">
							<InternalLink href="/privacy" className="text-blue">
								プライバシーポリシー
							</InternalLink>
							に同意の上、お進みください
						</p>
						<div className="mt-8 text-center fill-current">
							<Button className="w-52" type="button" fluffy={true} onClick={handleFormSubmit}>
								<span className="z-10">入力内容を確認する</span>
								<ArrowRight />
							</Button>
						</div>
					</form>
				</div>
				<p className="mt-5 lg:mt-8 text-xs">
					フォームで送信できない場合は、必要項目をご記入の上、
					<ExternalLink href="mailto:info@lisatech.jp" className="px-2 text-blue">
						info@lisatech.jp
					</ExternalLink>
					までメールをお送りください
				</p>
			</div>
		</div>
	)
}
